module.exports = __webpack_public_path__ + "static/media/roast-pork.9ba089b1.png";